/* eslint-disable import/prefer-default-export */
export const handleFetchErrors = (e, component) => {
  if (e.name === 'TypeError' && e.message.startsWith('Network')) {
    console.log(e);
    component.setState({ error: 'NetworkingError' });
  } else {
    console.log(e);
    console.log('code', e.code);
    console.log('name', e.name);
    console.log('message', e.message);
    component.setState({ error: e.code });
  }
};



// WEBPACK FOOTER //
// ./src/utils/errorHandler.js